var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.91,3.02h0c-4.97,0-8.99,4.04-8.98,9.01,0,4.97,4.04,8.99,9.01,8.98,4.97,0,8.99-4.04,8.98-9.01,0-.71-.09-1.42-.26-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.78,7.96c0-1.6-1.3-2.9-2.9-2.9,1.6,0,2.9-1.3,2.9-2.9,0,1.6,1.3,2.9,2.9,2.9-1.6,0-2.9,1.3-2.9,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.45,10.84l-.83,2.48c-.32.95-.14,1.98.45,2.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.03,7.08c.74.98.96,2.27.57,3.45l-1.03,3.1c-.39,1.18-.17,2.47.57,3.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.08,8.08c.59.78.77,1.81.45,2.76l-.83,2.48c-.32.95-.14,1.98.45,2.76"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/Steam.f013918ecd5e18fb75840facb4fbebc3.svg";
export { ForwardRef as ReactComponent };